import { useEffect } from "react";
import PageHeader from "../components/PageHeader";
import SectionHeading from "../components/SectionHeading";
import WhyGrid from "../components/sections/WhyGrid";
import ProcessTimeline from "../components/sections/ProcessTimeline";
import { Reveal } from "../components/Reveal";

export default function About() {
  useEffect(() => {
    document.title = "About — JOBLSX";
  }, []);

  return (
    <div>
      <PageHeader
        overline="Who We Are"
        title="Clarity over hype."
        subtitle="JOBLSX is a digital consulting company focused on helping clients improve performance, understand platform features, and optimize their digital presence — responsibly and transparently."
      />

      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <div className="grid items-center gap-12 lg:grid-cols-2">
            <Reveal>
              <div className="relative overflow-hidden rounded-3xl border border-white/10">
                <img
                  src="https://images.unsplash.com/photo-1614850523011-8f49ffc73908?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                  alt="Abstract technology"
                  className="h-[440px] w-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/70 to-transparent" />
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-500">Our Mission</p>
              <h2 className="mt-4 font-display text-3xl font-medium tracking-tight sm:text-4xl">
                We specialize in account management, growth, and technical guidance.
              </h2>
              <p className="mt-6 text-lg leading-relaxed text-slate-400">
                We work with creators, gamers, businesses, and professionals to build sustainable strategies grounded
                in each platform&rsquo;s public features and policies. Every recommendation is personalized, practical, and
                built to be executed with confidence.
              </p>
              <p className="mt-4 leading-relaxed text-slate-400">
                We prioritize privacy, transparent communication, and a client-first approach in everything we do.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-[#0a0a0a]">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <SectionHeading overline="Why Choose JOBLSX" title="What working with us feels like." className="mb-14" />
          <WhyGrid />
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <SectionHeading center overline="Our Process" title="How we work together." className="mb-16" />
          <ProcessTimeline />
        </div>
      </section>
    </div>
  );
}
